var map = {
	"./2018/data.json": [
		320,
		5
	],
	"./2019/data.json": [
		322,
		7
	],
	"./2020/data.json": [
		324,
		9
	],
	"./2021/data.json": [
		326,
		11
	],
	"./2022/data.json": [
		328,
		13
	],
	"./2023/data.json": [
		330,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 579;
module.exports = webpackAsyncContext;